import { ELogLevel, LoggerType } from '@services/errorService';
import { IGeneralRequestResponse } from '@services/httpClientService';

import { ICheckOrderExistsResponse } from './model';
import { isCheckOrderExistsResponse } from './model.guard';

export const mappingFunction = (
  result: IGeneralRequestResponse<ICheckOrderExistsResponse>,
  logger: LoggerType,
): ICheckOrderExistsResponse | null => {
  if (!isCheckOrderExistsResponse(result.data)) {
    logger({
      logLevel: ELogLevel.WARNING,
      logMessage: 'Unable to decode ICheckOrderExistsResponse model - check order exists',
    });
    return null;
  }

  return result.data;
};
